import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Stats } from "@/components/Stats";
import { About } from "@/components/About";
import { Capabilities } from "@/components/Capabilities";
import { AICapabilities } from "@/components/AICapabilities";
import { Vendors } from "@/components/Vendors";
import { Faq } from "@/components/Faq";
import { BookCall } from "@/components/BookCall";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppWidget } from "@/components/WhatsAppWidget";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
    const location = useLocation();

    useEffect(() => {
        document.title = "Syntera Technologies — AI, Cloud & Cybersecurity Solutions | Bengaluru";
    }, []);

    useEffect(() => {
        if (location.state?.scrollTo) {
            const target = location.state.scrollTo;
            window.history.replaceState({}, "");
            const t = setTimeout(() => scrollToId(target), 400);
            return () => clearTimeout(t);
        }
    }, [location.state]);

    return (
        <div className="bg-ink text-slate-100" data-testid="home-page">
            <Navbar />
            <main>
                <Hero />
                <Stats />
                <About />
                <Capabilities />
                <AICapabilities />
                <Vendors />
                <Faq />
                <BookCall />
                <Contact />
            </main>
            <Footer />
            <WhatsAppWidget />
        </div>
    );
}
